import axiosClient from "./axiosClient";

class ComboModel {
    constructor() {
        this.api_url = "/api/combo";
        this.admin_url = "/api/admin/combo";
    }

    async getPlans() {
        const res = await axiosClient.get(this.api_url + "/plans");
        return res;
    }

    async getStatus() {
        const res = await axiosClient.get(this.api_url + "/status");
        return res;
    }

    async createOrder(data) {
        const res = await axiosClient.post(this.api_url + "/order", data);
        return res;
    }

    async getMyOrders() {
        const res = await axiosClient.get(this.api_url + "/my-orders");
        return res;
    }

    // Admin APIs
    async adminGetOrders(params) {
        const res = await axiosClient.get(this.admin_url + "/orders", { params });
        return res;
    }

    async adminApprove(order_id) {
        const res = await axiosClient.post(this.admin_url + "/approve", { order_id });
        return res;
    }

    async adminReject(order_id, reason) {
        const res = await axiosClient.post(this.admin_url + "/reject", { order_id, reason });
        return res;
    }

    async adminSetUserSlots(data) {
        const res = await axiosClient.post(this.admin_url + "/set-user-slots", data);
        return res;
    }

    async adminAddUserSlots(data) {
        const res = await axiosClient.post(this.admin_url + "/add-user-slots", data);
        return res;
    }

    async adminResetBankExpiry(data) {
        const res = await axiosClient.post(this.admin_url + "/reset-bank-expiry", data);
        return res;
    }

    async adminResetUserAllBanksExpiry(data) {
        const res = await axiosClient.post(this.admin_url + "/reset-user-all-banks-expiry", data);
        return res;
    }

    async adminRenewBankAccount(data) {
        const res = await axiosClient.post(this.admin_url + "/renew-bank-account", data);
        return res;
    }

    async adminGetUserBanks(userId) {
        const res = await axiosClient.get(this.admin_url + "/user-banks/" + userId);
        return res;
    }
}

export default new ComboModel();
